import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getCategories, getShowCaseCat, getSingleCat, getTags, getAddOns, getBidAddOns, getServiceList, getShowServiceList, getSingleCatgeory } from '../../Apis/content';

export const Categories = createAsyncThunk('cateforiesss', async (formData, { rejectWithValue }) => {
    try {
        const response = await getCategories(formData);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

export const GetServiceList = createAsyncThunk('GetServiceList', async (formData, { rejectWithValue }) => {
    try {
        const response = await getServiceList(formData);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

export const GetShowServiceList = createAsyncThunk('GetShowServiceList', async (formData, { rejectWithValue }) => {
    try {
        const response = await getShowServiceList(formData);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});



export const CatSingle = createAsyncThunk('single cat', async (formData, { rejectWithValue }) => {
    try {
        const response = await getSingleCat(formData);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

export const CategorySingle = createAsyncThunk('CategorySingle', async (formData, { rejectWithValue }) => {
    try {
        const response = await getSingleCatgeory(formData);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});


export const ShowCaseCat = createAsyncThunk('showcaesss categories', async (_, { rejectWithValue }) => {
    try {
        const response = await getShowCaseCat();
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

export const TagsList = createAsyncThunk('tagsss', async (_, { rejectWithValue }) => {
    try {
        const response = await getTags();
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

export const AddOns = createAsyncThunk('AddOns', async (_, { rejectWithValue }) => {
    try {
        const response = await getAddOns();
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});
export const BidAddons = createAsyncThunk('BidAddons', async (_, { rejectWithValue }) => {
    try {
        const response = await getBidAddOns();
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});





const catSlice = createSlice({
    name: 'cat',
    initialState: {
        error: null,
        success: false,
        proData: [],
        showData: [],
        data: [],
        Single: [],
        categories: [],
        tags: [],
        addOn: [],
        showCat: [],
        bidAddon: [],
        category: {},
    },
    reducers: {
        clearCatStatus: state => {
            state.success = false;
            state.error = null;
        },

        clearCatVariables: state => {
            state.Single = [];
            state.categories = [];
            state.category = {};


        },
    },
    extraReducers: builder => {
        builder
            .addCase(Categories.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(Categories.fulfilled, (state, action) => {
                state.success = action.payload;
                state.error = null;
                state.data = action.payload.data.data;
            })
            .addCase(Categories.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })
            .addCase(GetServiceList.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(GetServiceList.fulfilled, (state, action) => {
                state.success = action.payload;
                state.error = null;
                state.proData = action.payload.data.services;
            })
            .addCase(GetServiceList.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })
            .addCase(GetShowServiceList.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(GetShowServiceList.fulfilled, (state, action) => {
                state.success = action.payload;
                state.error = null;
                state.showData = action.payload.data.services;
            })
            .addCase(GetShowServiceList.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })

            .addCase(CatSingle.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(CatSingle.fulfilled, (state, action) => {
                state.success = action.payload;
                state.error = null;
                state.Single = action.payload.data.data;
                state.categories = action.payload.data.categories;
                state.category = action.payload.data.category;
            })
            .addCase(CatSingle.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })
            .addCase(CategorySingle.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(CategorySingle.fulfilled, (state, action) => {
                state.success = action.payload;
                state.error = null;
                state.Single = action.payload.data.data;
            })
            .addCase(CategorySingle.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })


            .addCase(ShowCaseCat.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(ShowCaseCat.fulfilled, (state, action) => {
                state.success = action.payload;
                state.error = null;
                state.showCat = action.payload.data.data;
            })
            .addCase(ShowCaseCat.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })
            .addCase(TagsList.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(TagsList.fulfilled, (state, action) => {
                state.success = action.payload;
                state.error = null;
                state.tags = action.payload.data.data;
            })
            .addCase(TagsList.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })
            .addCase(AddOns.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(AddOns.fulfilled, (state, action) => {
                state.success = action.payload;
                state.error = null;
                state.addOn = action.payload.data.data;
            })
            .addCase(AddOns.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })
            .addCase(BidAddons.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(BidAddons.fulfilled, (state, action) => {
                state.success = action.payload;
                state.error = null;
                state.bidAddon = action.payload.data.data;
            })
            .addCase(BidAddons.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })
    },

});
export const { clearCatStatus, clearCatVariables } = catSlice.actions;
export default catSlice.reducer;

